module.exports = __webpack_public_path__ + "img/approved.1933bff3.jpg";